import { Component, Input, inject } from '@angular/core';
import { RoomAppointment, StudySpacesService } from '../study-spaces.service';
import { differenceInMinutes } from 'date-fns';
import { DatePipe } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-timetable',
  templateUrl: './timetable.component.html',
  styleUrls: ['./timetable.component.scss'],
  imports: [
    IonicModule,
    DatePipe
  ]
})
export class TimetableComponent  {
  studySpacesService = inject(StudySpacesService);

  @Input() appointments: RoomAppointment[];

  getMinutesNow(): number {
    return this.getMinutes(new Date());
  }

  getMinutes(date: Date): number {
    const startOfDay = new Date(date).setHours(0, 0, 0, 0);
    return differenceInMinutes( date, startOfDay );
  }

  range(length: number): number[] {
    return Array.from({length}, (_, k) => k);
  }
}
